<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2378_9340)">
      <path
        d="M2.89758 7.69971H0.233398V8.92904H2.89758V7.69971Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.89758 12.5518H0.233398V13.7811H2.89758V12.5518Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.4254 8.92896H0.708984V12.5494H2.4254V8.92896Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.71875 6.84133C0.71875 7.3153 1.10298 7.69954 1.57696 7.69954H1.66683C2.09117 7.69954 2.43517 7.35554 2.43517 6.9312V6.71014C2.43517 6.40789 2.68019 6.16287 2.98243 6.16287C3.28468 6.16287 3.5297 5.91785 3.5297 5.61561V4.58485C3.5297 4.32351 3.74155 4.11165 4.00289 4.11165C4.23049 4.11165 4.41889 3.94484 4.51862 3.74026C4.61931 3.53372 4.76838 3.34911 4.95681 3.20109C5.25252 2.96879 5.62623 2.84146 6.01228 2.84146C6.39834 2.84146 6.77205 2.96879 7.06775 3.20109C7.25618 3.34911 7.40526 3.53372 7.50594 3.74026C7.60568 3.94484 7.79407 4.11165 8.02167 4.11165C8.28301 4.11165 8.49487 4.32351 8.49487 4.58484V5.61561C8.49487 5.91785 8.73989 6.16287 9.04213 6.16287C9.34438 6.16287 9.5894 6.40789 9.5894 6.71014V6.9312C9.5894 7.35554 9.93339 7.69954 10.3577 7.69954H10.4464C10.9197 7.69954 11.3033 7.31586 11.3033 6.84257V1.21875C11.3033 0.666465 10.8556 0.21875 10.3033 0.21875H1.71875C1.16647 0.21875 0.71875 0.666465 0.71875 1.21875V6.84133Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7657 7.69971H9.10156V8.92904H11.7657V7.69971Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7657 12.5518H9.10156V13.7811H11.7657V12.5518Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.2936 8.92896H9.57715V12.5494H11.2936V8.92896Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.22392 2H2V5M10 5V2H8.77608"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2378_9340">
        <rect width="12" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
